<body>
    <div>
        <table class="table2">
            <thead>
                <th class="corlinha">
                    Janelas <abbr style="color: #89bb01; font-weight: bold;">LCB</abbr> Direto
                </th>
            </thead>
        </table>
        <div class="table2">
            <button (click)="abrirTabela('seg')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['seg']}">Segunda-Feira</button>
            <button (click)="abrirTabela('ter')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['ter']}">Terça-Feira</button>
            <button (click)="abrirTabela('qua')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['qua']}">Quarta-Feira</button>
            <button (click)="abrirTabela('qui')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['qui']}">Quinta-Feira</button>
            <button (click)="abrirTabela('sex')" class="button-spacing"
                [ngClass]="{'clicked': clickedButtons['sex']}">Sexta-Feira</button>
            <button (click)="inserirNova()" class="button-spacing newViagem"
                [class.disabled]="isButtonDisabled || isButtonDisabledHoje">Inserir viagem</button>
                <div class="dataEquantidade">
            <div>
                <label id="dataEntrega">Data da entrega: <abbr
                        style="color: #f8b146; font-weight: bold;">{{ selectedDate
                        | date: 'dd/MM/yyyy' }}</abbr></label>
            </div>
            <div class="totais">
                <label class="totais">Total Fornecedores: <abbr style="color: #89bb01; font-weight: bold;">{{
                        totalFornecedores }}</abbr></label>
                <!-- <input [disabled]="true" type="text" name="totalFornecedores" [(ngModel)]="totalFornecedores" class="modal-input1"> -->
                <label class="totais">Total MU's: <abbr style="color: #89bb01; font-weight: bold;">{{ totalMU
                        }}</abbr></label>
                <!-- <input [disabled]="true" type="text" name="totalMU" [(ngModel)]="totalMU" class="modal-input1"> -->
            </div>
        </div>
            <div class="table2">
                <table>
                    <thead>
                        <tr>
                            <th class="auto-width">
                                Fornecedor
                            </th>
                            <th class="auto-width">
                                Placa
                            </th>
                            <th class="auto-width">
                                Horário
                            </th>
                            <th class="auto-width">
                                MU's
                            </th>
                            <!-- <th class="auto-width">
                                WEB Stars
                            </th>
                            <th class="auto-width">
                                Confirmação Email
                            </th>
                            <th class="auto-width">
                                Descrição
                            </th>
                            <th class="auto-width">
                                Contatos
                            </th> -->
                            <th class="auto-width">
                                MP's
                            </th>
                            <th class="auto-width">
                                Anotações
                            </th>
                            <th class="auto-width">
                                Editar
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <ng-container *ngFor="let item of programacaoDiretasFiltradas">
                            <tr>
                                <td>{{ item.fornecedor }}</td>
                                <td>{{ item.placa }}</td>
                                <td>{{ item.horario }}</td>
                                <td>{{ item.quantidadeMU }}</td>
                                <!-- <td>{{ item.statusWebStars }}</td>
                                <td>{{ item.confirmacao }}</td>
                                <td>{{ item.descricao }}</td>
                                <td>
                                    <div class="contatos">
                                        <table>
                                            <tbody>
                                                <ng-container *ngFor="let contato of item.contatos">
                                                    <tr>
                                                        <td>{{ contato.nome }}</td>
                                                        <td>{{ contato.telefone }}</td>
                                                        <td>{{ contato.email }}</td>                                     
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </td> -->
                                <td>{{ item.mpName }}</td>
                                <td>{{ item.anotacoes }}</td>
                                <td>
                                    <i-feather name="edit" (click)="editDialog(item)"
                                        [class.disabled]="isButtonDisabled || isButtonDisabledHoje"></i-feather>
                                    <i-feather name="delete" (click)="deleteItem(item)"
                                        class="button-spacing"></i-feather>
                                        <i-feather [class.disabled]="usuarioLogado.role != 9" name="trash" (click)="deleteItemDB(item.ID)"
                                        class="button-spacing"></i-feather>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">Ajuste de Programação<br>
        <label id="dataEntrega">Data da entrega: <abbr
                style="color: #f8b146; font-weight: bold;">{{ selectedDate
                | date: 'dd/MM/yyyy' }}</abbr></label>
            </h3>
    <div class="modal-body" *ngIf="usuarioLogado">
        <form class="inputs">
            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Fornecedor</label>
                        <input [class.disabled]="usuarioLogado.role == 4" type="string" name="fornecedor" [(ngModel)]="item.fornecedor" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Placa</label>
                        <input [class.disabled]="usuarioLogado.role == 4" type="string" name="placa" [(ngModel)]="item.placa" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Horário</label><br>
                        <input [class.disabled]="usuarioLogado.role == 4" type="time" name="horario" [(ngModel)]="item.horario" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Quantidade de MU</label>
                        <input type="string" name="quantidadeMU" [(ngModel)]="item.quantidadeMU" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td [class.disabled]="usuarioLogado.role == 4">
                        <label class="modal-label">WEB Stars</label><br>
                        <!-- <td> -->
                        <select name="statusWebStars" [(ngModel)]="item.statusWebStars">
                            <option value="OK">OK</option>
                            <option value="Not OK">Not OK</option>
                        </select>
                        <!-- </td>
                        <input type="string" name="statusWebStars" [(ngModel)]="item.statusWebStars"
                            class="modal-input1"> -->
                    </td>
                    <td [class.disabled]="usuarioLogado.role == 4">
                        <label class="modal-label">Confirmação</label><br>
                        <select name="confirmacao" [(ngModel)]="item.confirmacao">
                            <option value="OK">OK</option>
                            <option value="Not OK">Not OK</option>
                        </select>
                        <!-- <input type="string" name="confirmacao" [(ngModel)]="item.confirmacao" class="modal-input1"> -->
                    </td>
                    <td [class.disabled]="usuarioLogado.role == 4">
                        <label class="modal-label">Descrição</label><br>
                        <!-- <input type="string" name="descricao" [(ngModel)]="item.descricao" class="modal-input1"> -->
                        <select name="descricao" [(ngModel)]="item.descricao">
                            <option value="DIRETO">DIRETO</option>
                            <option value="INDIRETO">INDIRETO</option>
                        </select>
                    </td>
                    <td>
                        <label class="modal-label">MP Name</label>
                        <input [class.disabled]="usuarioLogado.role == 4" type="string" name="mpName" [(ngModel)]="item.mpName" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td>
                        <table class="table2000">
                            <tr>
                                <td>
                                    <label class="modal-label">Anotações</label><br>
                                    <input type="text" name="anotacoes" [(ngModel)]="item.anotacoes"
                                        class="modal-input1 notes">
                                </td>
                            </tr>
                            <tr [class.disabled]="usuarioLogado.role == 4">
                                <td colspan="3">Contatos</td>
                                <td>
                                    <button type="button" (click)="adicionarContato()">Adicionar Contato</button>
                                </td>
                            </tr>
                            <tr [class.disabled]="usuarioLogado.role == 4" *ngFor="let contato of item.contatos; let i = index">
                                <td>
                                    <label class="modal-label">Nome</label>
                                    <input type="text" name="nome{{i}}" [(ngModel)]="contato.nome" class="modal-input1">
                                </td>
                                <td>
                                    <label class="modal-label">Telefone</label>
                                    <input type="text" name="telefone{{i}}" [(ngModel)]="contato.telefone"
                                        class="modal-input1">
                                </td>
                                <td>
                                    <label class="modal-label">Email</label>
                                    <input type="text" name="email{{i}}" [(ngModel)]="contato.email"
                                        class="modal-input1">
                                </td>
                                <td>
                                    <button type="button" (click)="removerContato(i)">Remover</button>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>